import React from 'react'
import { Skeleton, Tooltip, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useCustomers } from '../../customer'
import { useSuppliers } from '../../supplier'
import { formatSourceLabel } from '../utils/sourceMapPayload'

interface SourceRecordNameProps {
  companyId?: string
  sourceEntity: string
  sourceId: string
}

type SourceRecord = { id: number | string; name: string; vatId?: string }

const pickBySourceId = (sourceId: string) => (list: SourceRecord[]) => list.find(item => String(item.id) === sourceId)

// Resolves a source record id to its "Name · vatId" label at render time, running its own
// customers/suppliers query (shared cache keys, so no extra network). Keeps label resolution
// out of the wizard's data-shaping utils - see DimensionName for the same pattern.
const SourceRecordName: React.FC<SourceRecordNameProps> = ({ companyId, sourceEntity, sourceId }) => {
  const { t } = useTranslation()
  const pick = pickBySourceId(sourceId)
  const customer = useCustomers(companyId, pick)
  const supplier = useSuppliers(companyId, pick)
  const query = sourceEntity === 'Customer' ? customer : supplier

  if (query.isLoading) {
    return <Skeleton.Input active size="small" style={{ width: 140, minWidth: 140 }} />
  }

  if (query.data) {
    return <span>{formatSourceLabel(query.data)}</span>
  }

  return (
    <Tooltip
      title={t(
        'groupCustomerMapping:sourceRecordUnknownHint',
        'Lähdejärjestelmän tietolistaa ei voitu ladata tai tietuetta ei löytynyt.'
      )}
    >
      <Typography.Text type="secondary">
        {t('groupCustomerMapping:sourceRecordUnknown', 'Tuntematon tietue #{{id}}', { id: sourceId })}
      </Typography.Text>
    </Tooltip>
  )
}

export default SourceRecordName
